import { useMediaQuery } from '@uidotdev/usehooks'

/**
 * media queries
 * @param {*} device | mobile | laptop | tablet | desktop
 */

const useMedia = (device) => {
  switch (device) {
    case 'mobile':
      return useMediaQuery('only screen and (max-width : 480px)')

    case 'tablet':
      return useMediaQuery('only screen and (max-width : 768px)')

    case 'laptop':
      return useMediaQuery('only screen and (max-width: 1024px)')

    case 'desktop':
      return useMediaQuery('only screen and (max-width: 1200px)')

    default:
      return false
  }
}

export default useMedia
